import { render, staticRenderFns } from "./ConceptsOthers.vue?vue&type=template&id=387fa17e"
import script from "./ConceptsOthers.vue?vue&type=script&lang=ts"
export * from "./ConceptsOthers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports